var _style, _rect, _g, _path, _g2, _path2, _g3, _path3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuntimeSchemaCreation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.bg{\n    fill:#fff;\n}\n\n.stroke-main{\n    fill:none;\n    stroke:#111;\n    stroke-width:2;\n    stroke-linecap:round;\n    stroke-linejoin:round;\n}\n\n.fill-main{\n    fill:#111;\n}\n\n.text-sub{\n    font-family:system-ui,-apple-system,sans-serif;\n    font-size:11px;\n    font-weight:600;\n    fill:#111;\n    text-anchor:middle;\n}\n\n/* ---------- Nodes ---------- */\n\n#node1{\n    opacity:1;\n}\n\n#node2{\n    opacity:.15;\n    animation:fillNode2 4s ease-in-out infinite;\n}\n\n#node3{\n    opacity:.15;\n    animation:fillNode3 4s ease-in-out infinite;\n}\n\n#node4{\n    opacity:.15;\n    animation:fillNode4 4s ease-in-out infinite;\n}\n\n/* ---------- Arrows ---------- */\n\n#arrow1{\n    stroke-dasharray:70;\n    stroke-dashoffset:70;\n    animation:drawArrow1 4s ease-in-out infinite;\n}\n\n#arrow2{\n    stroke-dasharray:70;\n    stroke-dashoffset:70;\n    animation:drawArrow2 4s ease-in-out infinite;\n}\n\n#arrow3{\n    stroke-dasharray:70;\n    stroke-dashoffset:70;\n    animation:drawArrow3 4s ease-in-out infinite;\n}\n\n/* ---------- Keyframes ---------- */\n\n@keyframes drawArrow1{\n    0%,10%{\n        stroke-dashoffset:70;\n    }\n    25%,85%{\n        stroke-dashoffset:0;\n    }\n    100%{\n        stroke-dashoffset:70;\n    }\n}\n\n@keyframes fillNode2{\n    0%,23%{\n        opacity:.15;\n    }\n    28%,85%{\n        opacity:1;\n    }\n    100%{\n        opacity:.15;\n    }\n}\n\n@keyframes drawArrow2{\n    0%,33%{\n        stroke-dashoffset:70;\n    }\n    48%,85%{\n        stroke-dashoffset:0;\n    }\n    100%{\n        stroke-dashoffset:70;\n    }\n}\n\n@keyframes fillNode3{\n    0%,46%{\n        opacity:.15;\n    }\n    51%,85%{\n        opacity:1;\n    }\n    100%{\n        opacity:.15;\n    }\n}\n\n@keyframes drawArrow3{\n    0%,56%{\n        stroke-dashoffset:70;\n    }\n    71%,85%{\n        stroke-dashoffset:0;\n    }\n    100%{\n        stroke-dashoffset:70;\n    }\n}\n\n@keyframes fillNode4{\n    0%,69%{\n        opacity:.15;\n    }\n    74%,85%{\n        opacity:1;\n    }\n    100%{\n        opacity:.15;\n    }\n}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 800,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "node1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 70,
    y: 185,
    width: 80,
    height: 80,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M90 210 H120"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M90 225 H130"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M90 240 H110"
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 110,
    y: 295
  }, "1. Create Obj"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow1",
    className: "stroke-main",
    d: "M175 225 H235 M228 220 L235 225 L228 230"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "node2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 250,
    y: 185,
    width: 80,
    height: 80,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fill-main",
    cx: 266,
    cy: 210,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fill-main",
    cx: 266,
    cy: 225,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fill-main",
    cx: 266,
    cy: 240,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M280 210 H300"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M280 225 H300"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M280 240 H300"
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 290,
    y: 295
  }, "2. Save Meta"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "arrow2",
    className: "stroke-main",
    d: "M355 225 H415 M408 220 L415 225 L408 230"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "node3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 430,
    y: 185,
    width: 80,
    height: 80,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    opacity: 0.4,
    d: "M455 210 L485 240"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    opacity: 0.4,
    d: "M485 210 L455 240"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 460,
    y: 215,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 470,
    y: 295
  }, "3. Gen Schema"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "arrow3",
    className: "stroke-main",
    d: "M535 225 H595 M588 220 L595 225 L588 230"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "node4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 610,
    y: 185,
    width: 80,
    height: 80,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M630 210              C630 205 670 205 670 210              C670 215 630 215 630 210"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M630 222              C630 227 670 227 670 222              C670 217 630 217 630 222"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M630 234              C630 239 670 239 670 234              C670 229 630 229 630 234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M630 210 V234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M670 210 V234"
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 650,
    y: 295
  }, "4. DB Table"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuntimeSchemaCreation);
export default __webpack_public_path__ + "static/media/runtime-schema-creation.87b15d0bedcf8dfdcac97957cee471a4.svg";
export { ForwardRef as ReactComponent };